<shabic-dialog #dialog>
  <div class="w-full max-w-[500px] mx-auto">
    <header class="text-center">
      <div class="flex items-center justify-center mb-4">
        <img src="/assets/return-box.svg" />
      </div>

      <shabic-headline variant="h3">
        {{ 'common.replace-order' | translate }}
      </shabic-headline>
      <shabic-sub-headline>
        {{ 'common.replace-order-description' | translate }}
      </shabic-sub-headline>
    </header>

    <form
      class="mt-4 grid gap-4"
      [formGroup]="formGroup"
      (ngSubmit)="confirm(dialog)"
    >
      <!-- Reason Selection -->
      <div class="grid gap-1">
        <shabic-headline variant="h4" class="mb-2">
          {{ 'common.reason-for-replacement' | translate }}
        </shabic-headline>

        <shabic-form-field
          class="blok border-2 border-grey-350 rounded-2xl p-[20px]"
          [class.border-primary]="reasonControl.value === EReplaceOrderReason.DamagedGoods"
        >
          <shabic-radio-control>
            <input
              type="radio"
              id="damaged-goods"
              shabicInput
              formControlName="reason"
              class="peer"
              [value]="EReplaceOrderReason.DamagedGoods"
              name="reason"
            />

            <shabic-form-field-label forAttribute="damaged-goods">
              <span class="normal-case font-medium text-sm">
                {{ getReasonKey(EReplaceOrderReason.DamagedGoods) | translate }}
              </span>
            </shabic-form-field-label>
          </shabic-radio-control>
        </shabic-form-field>



        <shabic-form-field
          class="blok border-2 border-grey-350 rounded-2xl p-[20px]"
          [class.border-primary]="reasonControl.value === EReplaceOrderReason.QualityIssue"
        >
          <shabic-radio-control>
            <input
              type="radio"
              id="quality-issue"
              shabicInput
              formControlName="reason"
              class="peer"
              [value]="EReplaceOrderReason.QualityIssue"
              name="reason"
            />

            <shabic-form-field-label forAttribute="quality-issue">
              <span class="normal-case font-medium text-sm">
                {{ getReasonKey(EReplaceOrderReason.QualityIssue) | translate }}
              </span>
            </shabic-form-field-label>
          </shabic-radio-control>
        </shabic-form-field>

        <shabic-form-field
          class="blok border-2 border-grey-350 rounded-2xl p-[20px]"
          [class.border-primary]="reasonControl.value === EReplaceOrderReason.ExpiredProduct"
        >
          <shabic-radio-control>
            <input
              type="radio"
              id="expired-product"
              shabicInput
              formControlName="reason"
              class="peer"
              [value]="EReplaceOrderReason.ExpiredProduct"
              name="reason"
            />

            <shabic-form-field-label forAttribute="expired-product">
              <span class="normal-case font-medium text-sm">
                {{ getReasonKey(EReplaceOrderReason.ExpiredProduct) | translate }}
              </span>
            </shabic-form-field-label>
          </shabic-radio-control>
        </shabic-form-field>

        <shabic-form-field
          class="blok border-2 border-grey-350 rounded-2xl p-[20px]"
          [class.border-primary]="!reasonControl.value"
        >
          <shabic-radio-control>
            <input
              type="radio"
              id="other"
              shabicInput
              formControlName="reason"
              class="peer"
              [value]="null"
              name="reason"
            />

            <shabic-form-field-label forAttribute="other">
              <span class="normal-case font-medium text-sm">
                {{ 'common.other' | translate }}
              </span>
            </shabic-form-field-label>
          </shabic-radio-control>
        </shabic-form-field>

        <shabic-form-field *ngIf="!reasonControl.value" class="mt-4">
          <shabic-form-field-label forAttribute="reason">
            {{ 'common.description' | translate }}
          </shabic-form-field-label>

          <textarea
            shabicInput
            rows="4"
            id="reason"
            class="resize-none"
            formControlName="description"
          ></textarea>

          <div *ngIf="formGroup.get('description')?.errors?.['required'] && formGroup.get('description')?.touched" class="text-red text-sm mt-1">
            {{ 'common.required-field' | translate }}
          </div>
        </shabic-form-field>

        <!-- Reason validation error - only show when no option is selected -->
        <div *ngIf="reasonControl.errors?.['required'] && reasonControl.touched && reasonControl.value === null" class="text-red text-sm mt-1">
          {{ 'common.required-field' | translate }}
        </div>
      </div>

      <!-- Product Quantity Selection -->
      <div class="grid gap-3">
        <shabic-headline variant="h4" class="mb-2">
          {{ 'common.select-quantities-to-replace' | translate }}
        </shabic-headline>

        <div 
          *ngFor="let productForm of productForms; let i = index" 
          class="border border-grey-350 rounded-2xl p-4"
          [formGroup]="productForm"
        >
          <div class="flex justify-between items-center mb-3">
            <div class="flex-1">
              <shabic-headline variant="h5" class="font-medium">
                {{ productForm.get('productName')?.value }}
              </shabic-headline>
              <shabic-sub-headline class="text-grey">
                {{ 'common.original-quantity' | translate }}: {{ getMaxQuantity(productForm) }}
              </shabic-sub-headline>
            </div>
          </div>

          <shabic-form-field>
            <shabic-form-field-label forAttribute="quantity-{{i}}">
              {{ 'common.quantity-to-replace' | translate }} <span class="text-grey-500 text-sm font-normal">({{ 'common.pre-filled-total' | translate }})</span>
            </shabic-form-field-label>

            <input
              type="number"
              shabicInput
              id="quantity-{{i}}"
              formControlName="quantity"
              [min]="0"
              [max]="getMaxQuantity(productForm)"
              class="w-full"
            />

            <div *ngIf="productForm.get('quantity')?.errors?.['max']" class="text-red text-sm mt-1">
              {{ 'common.quantity-exceeds-original' | translate }}
            </div>
          </shabic-form-field>
        </div>
      </div>

      <!-- Disclaimer Section -->
      <div class="bg-blue-50 border border-blue-200 rounded-2xl p-4">
        <div class="flex items-start gap-3">
          <ng-template shabicIcon="alert" class="text-blue-500 mt-0.5"></ng-template>
          <div class="flex-1">
            <shabic-headline variant="h5" class="text-blue-700 mb-2">
              {{ 'common.replace-disclaimer-title' | translate }}
            </shabic-headline>
            <shabic-sub-headline class="text-blue-600 text-sm">
              {{ 'common.replace-disclaimer-text' | translate }}
            </shabic-sub-headline>
          </div>
        </div>
      </div>

      <!-- Photo Upload Section (Optional) -->
      <div class="grid gap-3">
        <shabic-headline variant="h4" class="mb-2">
          {{ 'common.upload-photos' | translate }} <span class="text-grey-500 text-sm font-normal">({{ 'common.optional' | translate }})</span>
        </shabic-headline>
        
        <div class="grid gap-3">
          <!-- Drag & Drop Zone -->
          <div 
            class="drag-zone border-2 border-dashed rounded-2xl p-4 text-center"
            [class.border-grey-350]="!isDragOver"
            [class.border-primary]="isDragOver"
            [class.bg-primary-50]="isDragOver"
            [class.drag-over]="isDragOver"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
          >
            <ng-template shabicIcon="picture" class="text-grey-500 mb-2 text-2xl"></ng-template>
            <p class="text-sm text-grey-600 mb-2">
              {{ 'common.drag-and-drop-photos' | translate }}
            </p>
            <p class="text-xs text-grey-500 mb-3">
              {{ 'common.max-files' | translate }}: {{ MAX_FILES }} | {{ 'common.max-size' | translate }}: {{ MAX_FILE_SIZE / 1024 / 1024 }}MB
            </p>
            <button
              type="button"
              shabicButton="secondary"
              class="text-sm"
              (click)="fileInput.click()"
            >
              {{ 'button.select-photos' | translate }}
            </button>
            <input
              #fileInput
              type="file"
              multiple
              accept="image/*"
              class="hidden"
              (change)="onFileSelected($event)"
            />
          </div>
          
          <!-- Upload Progress -->
          <div *ngIf="isUploading" class="upload-progress bg-blue-50 border border-blue-200 rounded-lg p-3 text-center">
            <div class="flex items-center justify-center gap-2">
              <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
              <span class="text-sm text-blue-700">{{ 'common.uploading-images' | translate }}...</span>
            </div>
          </div>
          
          <!-- Error Messages -->
          <div *ngIf="uploadErrors.length > 0" class="error-message bg-red-50 border border-red-200 rounded-lg p-3">
            <div class="flex items-center gap-2 mb-2">
              <ng-template shabicIcon="alert" class="text-red-500"></ng-template>
              <span class="text-sm font-medium text-red-700">{{ 'common.upload-errors' | translate }}</span>
            </div>
            <ul class="text-sm text-red-600 space-y-1">
              <li *ngFor="let error of uploadErrors">{{ error }}</li>
            </ul>
          </div>
          
          <!-- File Information -->
          <div *ngIf="selectedFiles.length > 0" class="file-info bg-grey-50 border border-grey-200 rounded-lg p-3">
            <div class="flex items-center justify-between mb-2">
              <span class="text-sm font-medium text-grey-700">
                {{ 'common.selected-files' | translate }} <span class="file-count">({{ selectedFiles.length }}/{{ MAX_FILES }})</span>
              </span>
              <button
                type="button"
                class="clear-all-btn text-xs text-red-600 hover:text-red-800 underline"
                (click)="clearAllFiles()"
              >
                {{ 'button.clear-all' | translate }}
              </button>
            </div>
            <p class="text-xs text-grey-600">
              {{ 'common.total-size' | translate }}: {{ getTotalFileSize() }}
            </p>
          </div>
          
          <!-- Selected Photos Preview -->
          <div *ngIf="selectedFiles.length > 0" class="grid grid-cols-2 gap-3">
            <div 
              *ngFor="let file of selectedFiles; let i = index" 
              class="file-preview relative border border-grey-200 rounded-lg p-3 bg-white shadow-sm"
            >
              <img 
                [src]="getFilePreview(file)" 
                class="w-full h-24 object-cover rounded mb-2"
                alt="Preview"
              />
              <div class="text-xs text-grey-600 mb-2">
                <div class="font-medium truncate">{{ file.name }}</div>
                <div>{{ getFileSize(file) }}</div>
              </div>
              <button
                type="button"
                class="remove-file-btn absolute top-2 right-2 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs"
                (click)="removeFile(i)"
                title="Remove file"
              >
                ×
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button
          type="submit"
          shabicButton="primary"
          class="w-full desktop:w-auto mt-5.5 mb-6"
          [disabled]="!isFormValid() || !hasValidReplacements || isUploading"
        >
          {{ 'button.confirm' | translate }}
        </button>
      </div>
    </form>
  </div>
</shabic-dialog> 